import { MapPin } from "lucide-react";
import { PageHero } from "@/pages/HowItWorks";
import { ComingSoon } from "@/components/ComingSoon";

export default function Facilities() {
  return (
    <div data-testid="facilities-page">
      <PageHero eyebrow="Find Facilities" title="Train Where You Thrive" subtitle="Discover gyms, courts and sports facilities near you — and check in with your partner." />
      <section className="py-16 md:py-24">
        <div className="px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          <div className="rounded-2xl border border-zinc-800 bg-zinc-900/60 p-10 text-center">
            <span className="grid place-items-center w-16 h-16 rounded-2xl bg-[#E53E3E]/10 text-[#E53E3E] mx-auto"><MapPin className="w-8 h-8" /></span>
            <h2 className="mt-6 font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight">The facility directory is on its way</h2>
            <p className="mt-3 text-zinc-400 max-w-lg mx-auto">We're building a searchable map of partner gyms, courts and sports venues with check-in support. This feature arrives in a later stage of FitLynk.</p>
            <div className="mt-8">
              <ComingSoon title="Facility Search & Check-ins" description="Browse nearby facilities, view amenities, and check in at the venue with your accountability partner." className="text-left" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
